import type { CreatorInvitationUnavailableState } from "../hooks/useCreatorInvitation";

export const formatCreatorInvitationExpiryUtc = (value?: string) => {
	if (!value) return "its expiry date";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "its expiry date";
	return new Intl.DateTimeFormat("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
		timeZone: "UTC",
	}).format(date);
};

export const getCreatorInvitationUnavailableCopy = (state: CreatorInvitationUnavailableState) => {
	switch (state.reason) {
		case "expired":
			return {
				title: "This invite link has expired",
				body: `Link expired on ${formatCreatorInvitationExpiryUtc(state.expiredAt)}, so it can no longer be used to set up your Creatorverse account.`,
			};
		case "already_used":
			return {
				title: "This invite link has already been used",
				body: "This link was used to set up a Creatorverse account. If that wasn't you, or you can't get into your account, your Campaigns Team can sort it out.",
			};
		case "revoked":
			return {
				title: "This invite link is no longer active",
				body: "Your Campaigns Team withdrew this invite before it was opened. If you were expecting to join this campaign, ask them to send you a new one.",
			};
		default:
			return {
				title: "We couldn't open this invitation",
				body: state.message,
			};
	}
};

const fallbackCampaignsTeamEmail = () => import.meta.env.VITE_CAMPAIGNS_TEAM_EMAIL || "hello@thecreatorverse.co";

export const getCreatorInvitationUnavailableAction = (state: CreatorInvitationUnavailableState) => {
	if (state.reason === "unknown") {
		return { label: "Back to Creatorverse", href: "/" as const };
	}
	const contactEmail = state.contactEmail || fallbackCampaignsTeamEmail();
	return {
		label: "Contact your Campaigns Team",
		href: `mailto:${contactEmail}?subject=${encodeURIComponent("Creatorverse invitation help")}`,
	};
};
